const apiUrl = process.env.REACT_APP_API_URL ?? ''


const configs = { 
  test: {
    base_url: `${apiUrl}`,
  },
};


export const config = configs.test;
